import { render, staticRenderFns } from "./QlikSelectedFilterPills.vue?vue&type=template&id=f54e122c&"
import script from "./QlikSelectedFilterPills.vue?vue&type=script&lang=js&"
export * from "./QlikSelectedFilterPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports